import React from 'react';
import { getLoginURL, getCreateAccountURL } from '@insight/toolkit-utils';
import { CalloutBox } from '@insight/toolkit-react';
export const CTABox = ({isLoggedOutIPS, categoryType}) => {
    return <CalloutBox isLoggedOutIPS={isLoggedOutIPS} loginLink={getLoginURL()} accountLink={getCreateAccountURL()} categoryType={categoryType} />
}
